module.exports = __webpack_public_path__ + "img/header_bg.f70f65a1.png";